/**
 * by Aleksandar Panic
 **/
import { sendDelete, sendGet, sendPost, sendFormData } from "./base";

export function getData() {
    return sendGet('user/data');
}

export function getPasswordRequirements() {
    return sendGet('user/password-requirements');
}

export function resetPassword({ current_password, new_password }) {
    return sendPost('user/reset-password', { current_password, new_password });
}

export function resetPasswordViaToken({ token, new_password }) {
    return sendPost('user/token-reset-password', { token, new_password });
}

export function setupPasswordViaToken({ token, new_password }) {
    return sendPost('user/token-setup-password', { token, new_password });
}

export function requestPasswordReset({ email }) {
    return sendPost('user/request-reset', { email });
}

export function getMfaStatus() {
    return sendGet('user/mfa-status');
}

export function setupMfa({ code, type }) {
    return sendPost('user/setup-mfa', { code, type });
}

export function removeMfa() {
    return sendDelete('user/setup-mfa');
}

export function getProfilePhotoUrl() {
    return sendGet('user/profile-photo');
}

export function saveProfilePhoto({ photo, upload }) {
    return sendFormData('user/profile-photo', { photo, upload });
}